// Module
var code = `<span class="hidden-element" ng-if="!\$ctrl.condition">
  <input class="hidden-element" disabled ng-required="true" ng-model="__nonExistingValue"/>
</span>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/validator/validator.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;